import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from '@/store'
import router from '@/routes/index'

import i18n from './i18n'
import uploader from 'vue-simple-uploader'
import VueSession from 'vue-session'
import VeeValidate from 'vee-validate'
import VueTreeList from 'vue-tree-list'

//import CKEditor from 'ckeditor4-vue';
import CKEditor from 'ckeditor4-vue/dist/legacy.js'; // ie11
//import CKEditor from '@ckeditor/ckeditor5-vue2';
import history from 'connect-history-api-fallback';

// import Antd from 'ant-design-vue';
// 사용할 antd 태그만 불러서 사용
import Tree from 'ant-design-vue/es/tree';
Vue.use(Tree)

import 'ant-design-vue/dist/antd.css';
import vueMoment from 'vue-moment';
import Dropdown from 'vue-simple-search-dropdown';

import Loading from 'vue-loading-overlay'; // refer: https://github.com/ankurk91/vue-loading-overlay
import 'vue-loading-overlay/dist/vue-loading.css';


// 부트스트랩
// 필요한 플러그인만 빼서 사용
import { LayoutPlugin, FormDatepickerPlugin } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.config.productionTip = false
Vue.use(LayoutPlugin)
Vue.use(FormDatepickerPlugin)

// Vue.use(Antd)
Vue.use(vueMoment)
Vue.use(Dropdown)
Vue.use(Loading)

var sessionOptions = {
    persist: true,
};
Vue.use(uploader)
Vue.use(VueSession, sessionOptions);
Vue.use(VeeValidate)

Vue.use(VueTreeList)
Vue.use(history)
Vue.use(CKEditor)



window.$ = window.jQuery = require('jquery');
import '@/js/bootstrap.bundle.min.js';

let owl_carousel = require('owl.carousel');
window.fn = owl_carousel;


import '@/css/bootstrap.min.css';
import '@/css/layout.css';
import '@/css/mquery.css';
import '@/css/custom-layout.css';
import '@/css/custom-mquery.css';

// Vue.prototype.$isIE = /*@cc_on!@*/ false || !!document.documentMode;
let isIE = (navigator.userAgent.indexOf("MSIE") !== -1) || (!!document.documentMode) === true;
Vue.prototype.isIE = isIE;



new Vue({
    vuetify,
    i18n,
    store,
    router,
    render: h => h(App)
}).$mount('#app')